$(document).ready(function() {
  $('.product_template_change .spoiler').click(function() {
    $(this).next().toggleClass('hidden');
  });
});